export default __webpack_public_path__ + "static/media/bg.min.618da54a.jpg";